import React from "react";
import "../assets/scss/main.scss"; 

import flatartImage from "../assets/img/main/flatart_slider_mobile.jpg"; 

const FlatartTopBanner = () => {
  return (
    <div className="flatart-banner-container mobile">
      <img
        src={flatartImage}
        alt="Flatart Slider"
        className="flatart-banner-image"
        loading="lazy"
       
      />
    </div>
  );
};

export default FlatartTopBanner;
